import React from "react";
import { OverlayView } from "@react-google-maps/api";

const TruckMarker = ({ lat, lng, heading = 0, ppu }) => {
    if (!lat || !lng) return null;

    return (
        <OverlayView
            position={{ lat: Number(lat), lng: Number(lng) }}
            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
        >
            <div
                style={{
                    transform: `translate(-50%, -50%) rotate(${heading}deg)`,
                    width: 40,
                    height: 40,
                }}
                title={`Truck ${ppu || ""}`}
            >
                <img
                    src="/images/icons/truck-top.svg"
                    width={40}
                    height={40}
                    alt="truck"
                />
            </div>
        </OverlayView>
    );
};

export default TruckMarker;
